import Vue from 'vue';
import App from './App.vue';
import { rtdbPlugin } from 'vuefire';
import router from './router';

Vue.config.productionTip = false;
Vue.use(rtdbPlugin);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');

// new Vue({
//   el: '#app',
//   template: '<App/>',
//   components: { App },
//   data: {
//     loader: true,
//   },
// });

// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('./service-worker.js');
//   });
// }
